import { useState, useEffect } from "react";
import api from "../services/api";
import { useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { faSquareCaretLeft } from "@fortawesome/free-solid-svg-icons";

const Relaciones = () => {
    const [IdPersona1, setIdPersona1] = useState("");
    const [IdPersona2, setIdPersona2] = useState("");
    const [idTipoRelacion, setIdTipoRelacion] = useState("");
    const [conviviente, setConviviente] = useState(false);
    const [personas, setPersonas] = useState([]);
    const [tiposRelacion, setTiposRelacion] = useState([]);
    const [mensaje, setMensaje] = useState("");

    const navigate = useNavigate();

    useEffect(() => {
        leerPersonas();
        getTiposRelacion(); // Añadido para obtener los tipos de relación
    }, []);
    
    const getTiposRelacion = async () => {
        try {
            const response = await api.get(`tiposRelacion`);
            setTiposRelacion(response.data);
        } catch (error) {
            console.error(error.message);
        }
    };
    
    const createRelacion = async (e) => {
        e.preventDefault();
        try {
            await api.post(`/createRelacion`, {  // Asegúrate de que la URL sea correcta
                IdPersona1,
                IdPersona2,
                idTipoRelacion,
                conviviente
            });
            setIdPersona1("");
            setIdPersona2("");
            setIdTipoRelacion("");
            setConviviente(false);
            setMensaje("Relación creada con éxito.");
        } catch (error) {
            console.log(error);  // Verifica el error completo
            setMensaje("Error al crear la relación.");
        }
    };
    

    const leerPersonas = async () => {
        const response = await api.get(`/leerPersonas`);
        setPersonas(response.data);
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <div className="columns mt-5 is-centered">
            <div className="column is-half">
                <label className="label">Agregar relaciones</label>
                <br />
                {mensaje && <div className="notification is-primary">{mensaje}</div>}
                <form onSubmit={createRelacion}>
                    <div className="field">
                        <label className="label">Persona 1</label>
                        <div className="select is-fullwidth">
                            <select
                                value={IdPersona1}
                                onChange={(e) => setIdPersona1(e.target.value)}
                                required
                            >
                                <option value="">Seleccionar</option>
                                {personas.map((persona) => (
                                    <option value={persona.IdPersona} key={persona.IdPersona}>
                                        {persona.Nombre} {persona.Apellido}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="field">
                        <label className="label">Persona 2</label>
                        <div className="select is-fullwidth">
                            <select
                                value={IdPersona2}
                                onChange={(e) => setIdPersona2(e.target.value)}
                                required
                            >
                                <option value="">Seleccionar</option>
                                {personas.map((persona) => (
                                    <option value={persona.IdPersona} key={persona.IdPersona}>
                                        {persona.Nombre} {persona.Apellido}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="field">
                        <label className="label">Tipo de Relación</label>
                        <div className="select is-fullwidth">
                            <select
                                value={idTipoRelacion}
                                onChange={(e) => setIdTipoRelacion(e.target.value)}
                                required
                            >
                                <option value="">Seleccionar</option>
                                {tiposRelacion.map((tipo) => (
                                    <option value={tipo.IdTipoRelacion} key={tipo.IdTipoRelacion}>
                                        {tipo.Nombre}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="field">
                        <label className="label">Conviviente</label>
                        <div className="control">
                            <input
                                type="checkbox"
                                checked={conviviente}
                                onChange={(e) => setConviviente(e.target.checked)}
                            />
                        </div>
                    </div>
                    <div className="level">
                        <div className="level-left">
                            <FontAwesomeIcon icon={faSquareCaretLeft} size="2xl" style={{ color: "#3488CE", cursor: "pointer" }} onClick={handleGoBack} />
                        </div>
                        <div className="field level-right">
                            <button type="submit" className="level-item" style={{ border: "none", backgroundColor: "#00ff11", color: "white" }}>
                                Guardar <FontAwesomeIcon icon={faCheck} size="2xl" style={{ color: "white" }} />
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Relaciones;
